import * as React from "react"
import { Route, Routes } from "react-router-dom"

import Catalog from "Catalog"
import Home from "Home"
import PageError from "shared/components/PageError"

const AppRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/catalogs/:catalogId/*" element={<Catalog />} />
      <Route path="*" element={<PageError error={"Page not found"} />} />
    </Routes>
  )
}

export default AppRoutes
